import axios from "axios";
import * as ActionType from "./staff.type";
import { setToast } from "../../../util/toast";
import { apiInstanceFetch } from "../../../util/api";

// Get Staff
export const getStaff = (page, limit) => (dispatch) => {
  apiInstanceFetch
    .get(`subAdmin/mapSubAdmins?start=${page}&limit=${limit}`, true)
    .then((res) => {
      if (res.status) {
        dispatch({
          type: ActionType.GET_STAFF,
          payload: { data: res.data, total: res.total },
        });
      } else {
        setToast("error", res.message);
      }
    })
    .catch((error) => {
      console.log(error);
      setToast("error", "Failed to fetch staff list.");
    });
};

// Create Staff
export const createStaff = (data) => (dispatch) => {
  return axios
    .post("subAdmin/registerSubAdminUnit", data , {
      headers: {
        "Authorization": `${sessionStorage.getItem("token")}`,
      },
    })
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.CREATE_STAFF, payload: res.data?.subAdmin }); // adjust based on actual API return
        setToast("success", res?.data?.message);
        return res.data;
      } else {
        setToast("error", res?.data?.message);
        return { status: false };
      }
    })
    .catch((error) => {
      console.log(error);
      setToast("error", "Failed to create staff.");
      return { status: false };
    });
};

// Edit Staff
export const editStaff = (data) => (dispatch) => {
  return axios
    .patch("subAdmin/reconfigureSubAdmin", data , {
      headers: {
        "Authorization": `${sessionStorage.getItem("token")}`,
      },
    })
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.EDIT_STAFF, payload: res?.data?.subAdmin }); // adjust based on actual API return
        setToast("success", res?.data?.message);
        return res.data;
      } else {
        setToast("error", res?.data?.message);
        return { status: false };
      }
    })
    .catch((error) => {
      console.log(error);
      setToast("error", "Failed to update staff.");
      return { status: false };
    });
};

// Toggle Staff Status
export const toggleStaffStatus = (staffId) => (dispatch) => {
  apiInstanceFetch
  .patch(`subAdmin/switchSubAdminStatus?subAdminId=${staffId}`)
  .then((res) => {
      if (res?.status) {
        dispatch({ type: ActionType.UPDATE_STAFF_STATUS, payload: staffId }); // optimistically toggle
        setToast("success", res?.message);
      } else {
        setToast("error", res?.message);
      }
    })
    .catch((error) => {
      console.log(error);
      setToast("error", error?.message);
    });
};

// Delete Staff
export const deleteStaff = (staffId) => (dispatch) => {
  axios
    .delete(`subAdmin/sunsetSubAdmin?subAdminId=${staffId}` , {
      headers: {
        "Authorization": `${sessionStorage.getItem("token")}`,
      },
    })
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.DELETE_STAFF, payload: staffId });
        setToast("success", "Staff deleted successfully.");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log(error);
      setToast("error", "Failed to delete staff.");
    });
};
